// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewCount-textError-g2smu {
	color: #d43242;
}

.ViewCount-noBackground-vp6hl {
	background-color: transparent !important;
}

.ViewCount-avatarImage-RpoU8 {
	display: grid;
	grid-template-columns: 80px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 20px;
}

.ViewCount-imageSection-Rcj1V {
	display: grid;
	grid-template-columns: 56px auto;
}

.ViewCount-textSection-sQG4b {
	margin-left: 20px;
}

.ViewCount-profileAvatar-i1sJW {
	border-radius: 50%;
}

.ViewCount-profileAvatarLink-h7R_t {
	border: 2px solid var(--common-link-color);
	border-radius: 50%;
	display: inline-block;
	padding: 5px;
	background-color: transparent;
}

.ViewCount-reviewStarSection-oPadD {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
}

.ViewCount-dotSection-xfQAZ {
	position: relative;
	padding-left: 14px;
}

.ViewCount-dotSection-xfQAZ::before {
	content: '';
	position: absolute;
	top: 8px;
	left: 5px;
	width: 4px;
	height: 4px;
	background-color: var(--common-text-color);
	border-radius: 100%;
}

.ViewCount-starImageMargin-BXsxd {
	margin-right: 3px;
}

.ViewCount-reviewCountFlex-Z5VvL {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center
}

.ViewCount-bookItMessage-UnK7H {
  overflow: hidden;
  display: block;
  position: relative;
  border-top: 1px solid var(--primary-border);
  padding-top: 12px;
  margin-top: 12px;
}

@media screen and (max-width: 767px) {
  .ViewCount-mobileTextSize-nfs2W {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css","webpack://./src/components/ViewListing/ViewCount/ViewCount.css"],"names":[],"mappings":"AAAA;CACC,cAAc;AACf;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,WAAW;CACX,0CAA0C;CAC1C,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAkB;KAAlB,sBAAkB;SAAlB;AACD;;AC9DA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".textError {\n\tcolor: #d43242;\n}\n\n.noBackground {\n\tbackground-color: transparent !important;\n}\n\n.avatarImage {\n\tdisplay: grid;\n\tgrid-template-columns: 80px auto;\n\talign-items: center;\n\tgap: 20px;\n}\n\n.imageSection {\n\tdisplay: grid;\n\tgrid-template-columns: 56px auto;\n}\n\n.textSection {\n\tmargin-left: 20px;\n}\n\n.profileAvatar {\n\tborder-radius: 50%;\n}\n\n.profileAvatarLink {\n\tborder: 2px solid var(--common-link-color);\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tpadding: 5px;\n\tbackground-color: transparent;\n}\n\n.reviewStarSection {\n\tdisplay: flex;\n\talign-items: baseline;\n}\n\n.dotSection {\n\tposition: relative;\n\tpadding-left: 14px;\n}\n\n.dotSection::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 8px;\n\tleft: 5px;\n\twidth: 4px;\n\theight: 4px;\n\tbackground-color: var(--common-text-color);\n\tborder-radius: 100%;\n}\n\n.starImageMargin {\n\tmargin-right: 3px;\n}\n\n.reviewCountFlex {\n\tdisplay: flex;\n\talign-items: center\n}","@import '../common.css';\n\n.bookItMessage {\n  overflow: hidden;\n  display: block;\n  position: relative;\n  border-top: 1px solid var(--primary-border);\n  padding-top: 12px;\n  margin-top: 12px;\n}\n\n@media screen and (max-width: 767px) {\n  .mobileTextSize {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textError": `ViewCount-textError-g2smu`,
	"noBackground": `ViewCount-noBackground-vp6hl`,
	"avatarImage": `ViewCount-avatarImage-RpoU8`,
	"imageSection": `ViewCount-imageSection-Rcj1V`,
	"textSection": `ViewCount-textSection-sQG4b`,
	"profileAvatar": `ViewCount-profileAvatar-i1sJW`,
	"profileAvatarLink": `ViewCount-profileAvatarLink-h7R_t`,
	"reviewStarSection": `ViewCount-reviewStarSection-oPadD`,
	"dotSection": `ViewCount-dotSection-xfQAZ`,
	"starImageMargin": `ViewCount-starImageMargin-BXsxd`,
	"reviewCountFlex": `ViewCount-reviewCountFlex-Z5VvL`,
	"bookItMessage": `ViewCount-bookItMessage-UnK7H`,
	"mobileTextSize": `ViewCount-mobileTextSize-nfs2W`
};
module.exports = ___CSS_LOADER_EXPORT___;
